import styled from 'styled-components';
import {Body2, Heading2} from '../../../styles/typography';

const Container = styled.div`
	margin: 0 auto;
	max-width: 80rem;
	padding: 24px;
`;
const Title = styled(Heading2)`
	color: ${p => p.theme.sys.color.text.content.main};
`;
const Placeholder = styled(Body2)`
	margin: 8px 0 0;
	color: ${p => p.theme.sys.color.text.content.auxiliary};
`;

export function DashboardRoute() {
	return (
		<Container>
			<Title>Dashboard</Title>
			<Placeholder>The ticket dashboard is coming soon.</Placeholder>
		</Container>
	);
}
